import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css'],
  standalone: false
})
export class ViewComponent implements OnInit {

  private _image: string;
  set image(value: string) {
    this._image = value;
  }
  get image() {
    return this._image;
  }

  private _keyModifier = "???";
  set keyModifier(value: string) {
    if (value == 'Cmd')
      this._keyModifier = '⌘';
    else if (value == 'Ctrl') {
      this._keyModifier = '⌃';
    }
    this.change.detectChanges();
  }
  get keyModifier() {
    return this._keyModifier;
  }

  constructor(
    private change: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }
}
